import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { INewbuildingHeaderSeoUrl } from '../../../../types/newbuildingHeader';

interface ITitleProps {
  title: string;
  url?: INewbuildingHeaderSeoUrl;
}

export const Title: React.FC<ITitleProps> = ({ title, url }) => {
  return (
    <UIText3 color="surface-neutral-pressed" as="h1">
      {title}
      {url && (
        <a href={url.href} target="_blank" rel="noreferrer" className={styles['link']}>
          {url.text}
        </a>
      )}
    </UIText3>
  );
};
